<template>
  <div>
    <div class="footer__social--link">
      <p-link
        v-for="(item, index) in paribuLinks"
        :key="`paribuLinks-${index}`"
        size="md"
        target="_blank"
        :label="item.name"
        :href="item.link"
        :rel="item.rel"
      />
    </div>

    <div class="t-fg-primary f-body-16-bold mb-24" v-text="$t('paribu.community')" />

    <div class="footer__social-icons">
      <a
        v-for="({ media, link, title }, index) in medias"
        :key="`media-${index}`"
        :href="link"
        :title="title"
        target="_blank"
        rel="nofollow noopener"
      >
        <img
          v-if="media === 'tiktok'"
          src="/icon/tiktok.svg"
          width="24"
          height="24"
          :alt="title"
          class="t-fg-primary"
        />
        <img
          v-else-if="media === 'reddit'"
          src="/icon/reddit.svg"
          width="24"
          height="24"
          :alt="title"
          class="t-fg-primary"
        />
        <p-icon v-else color="fg-primary" :icon="media" />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
const paribuLinks = [
  {
    name: 'Paribu Custody',
    link: 'https://custody.paribu.com/',
    rel: 'nofollow noopener',
  },
  {
    name: 'Paribu Custody TR',
    link: 'https://custody.paribu.com/turkiye/',
    rel: 'nofollow noopener',
  },
  {
    name: 'ParibuLog',
    link: 'https://www.paribu.com/blog/',
  },
  {
    name: 'Paribu Hub',
    link: 'https://www.paribu.com/hub/',
  },
  {
    name: 'Team Paribu',
    link: 'https://team.paribu.com/',
    rel: 'nofollow noopener',
  },

  {
    name: 'Paribu Ventures',
    link: 'https://ventures.paribu.com/',
    rel: 'nofollow noopener',
  },
  {
    name: 'Paribu Art',
    link: 'https://art.paribu.com/',
    rel: 'nofollow noopener',
  },
  {
    name: 'Paribu Pass',
    link: 'https://pass.paribu.com/',
    rel: 'nofollow noopener',
  },
]

const medias = [
  { media: 'youtube', link: 'https://www.youtube.com/c/Paribu', title: 'Paribu YouTube' },
  { media: 'twitter', link: 'https://x.com/paribucom', title: 'Paribu X' },
  { media: 'linkedin', link: 'https://www.linkedin.com/company/paribu/', title: 'Paribu Linkedin' },
  { media: 'instagram', link: 'https://www.instagram.com/paribucom/', title: 'Paribu Instagram' },
  { media: 'facebook', link: 'https://www.facebook.com/paribucom', title: 'Paribu Facebook' },
  { media: 'tiktok', link: 'https://www.tiktok.com/@paribucom', title: 'Paribu TikTok' },
  { media: 'reddit', link: 'https://www.reddit.com/user/paribu/', title: 'Paribu Reddit' },
]
</script>
